"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pavia-di-udine": {
    "565a58a3": [{
      "hkey": "f6679eb9",
      "slug": "popereacco-ronchi",
      "name": "Popereacco-Ronchi",
      "primary": true,
      "skipSearch": false
    }],
    "popereacco": [{
      "hkey": "f6679eb9",
      "slug": "popereacco-ronchi",
      "name": "Popereacco-Ronchi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "57034071": [{
      "hkey": "f6679eb9",
      "slug": "popereacco-ronchi",
      "name": "Popereacco-Ronchi",
      "primary": true,
      "skipSearch": false
    }],
    "ronchi": [{
      "hkey": "f6679eb9",
      "slug": "popereacco-ronchi",
      "name": "Popereacco-Ronchi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pavia-di-udine"
    }]
  }
};
exports["default"] = _default;